import { Pipe, PipeTransform } from '@angular/core';

import { COUNTRY_OPTIONS } from '@shared/constants';

@Pipe({
  name: 'countryName',
  standalone: true,
})
export class CountryNamePipe implements PipeTransform {
  private countryMap = new Map(COUNTRY_OPTIONS.map((c) => [c.value, c.label]));

  transform(value?: string | string[] | null, separator = ', '): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      return value.map((code) => this.countryMap.get(code) ?? code).join(separator);
    }

    return this.countryMap.get(value) ?? value;
  }
}
